import {
  setDoc,
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  where,
  addDoc,
  serverTimestamp,
  updateDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { UserData } from '../types';

export const searchUsers = async (
  searchTerm: string,
  currentUserId: string
): Promise<UserData[]> => {
  const usersRef = collection(db, 'users');
  const q = query(
    usersRef,
    where('username', '>=', searchTerm.toLowerCase()),
    where('username', '<=', searchTerm.toLowerCase() + '\uf8ff')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs
    .map((d) => d.data() as UserData)
    .filter((u) => u.id !== currentUserId);
};

export const getOrCreateConversation = async (
  uid1: string,
  uid2: string
): Promise<string> => {
  const conversationId = [uid1, uid2].sort().join('_');
  const ref = doc(db, 'conversations', conversationId);
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    await setDoc(ref, {
      members: [uid1, uid2].sort(),
      lastMessage: null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }

  return conversationId;
};

export const sendMessage = async (
  conversationId: string,
  senderId: string,
  text: string
) => {
  const messagesRef = collection(
    db,
    'conversations',
    conversationId,
    'messages'
  );
  const conversationRef = doc(db, 'conversations', conversationId);

  await addDoc(messagesRef, {
    senderId,
    text,
    createdAt: serverTimestamp(),
  });

  await updateDoc(conversationRef, {
    lastMessage: {
      text,
      senderId,
      createdAt: Timestamp.now(),
    },
    updatedAt: serverTimestamp(),
  });
};
